import { Action } from '@ngrx/store';

export enum UiSettingsActionType {
  TOGGLE_TEST_DATA = '[UI Settings] Toggle Test Data',
  SET_TEST_DATA = '[UI Settings] Set Test Data',
}

export class ToggleTestDataAction implements Action {
  readonly type = UiSettingsActionType.TOGGLE_TEST_DATA;
}

export class SetTestDataAction implements Action {
  readonly type = UiSettingsActionType.SET_TEST_DATA;

  constructor(public payload: boolean) {}
}

export type UiSettingsActions = ToggleTestDataAction | SetTestDataAction;